import { commonValidateEmail, commonValidateTel, commonValidMobileForCloudECounter } from '@/views/aplCatl640and631/BCBD/landingPage/validate';
import { checkAddress } from '@/utils/rules/checkAddr';
import { $vfm } from 'vue-final-modal';
import router from '@/router';
import routeName from '@/router/constant';
import { getCityInfo, getMobileCodeInfo, postInfo, postProfession, postRelation, postBusinessData, postProfessionSub } from '@/apis/applicantChange';
import { openPopupCatchMessage } from '@/utils/vfmUtils';

export function validateEmail(item, errors) {
    const { email } = item;
    errors.email = commonValidateEmail({
        mail: email,
        isRequired: false,
    });
}

export function validateMobile(item, errors) {
    const {
        mobileCountry,
        mobile,
    } = item;
    errors.mobile = commonValidMobileForCloudECounter({
        mobileCountry,
        mobile,
        isRequired: true,
    });
}

export function validateAddress(item, errors) {
    const {
        address,
        city,
        cityArea,
    } = item;
    if (!address && !city && !cityArea) return;

    if (city === '' || cityArea === '' || address === '') {
        errors.city = item.city === '' ? '請輸入縣市' : '';
        errors.cityArea = item.cityArea === '' ? '請輸入鄉鎮' : '';
        errors.address = item.address === '' ? '請輸入地址' : '';
    } else {
        errors.city = '';
        errors.cityArea = '';
        const en = /^[^a-zA-Z]+$/.test(item.address);
        if (!en) {
            errors.address = '不接受英文地址，請改以中文輸入';
        } else {
            const message = checkAddress(address).msg;
            errors.address = message[0] || '';
        }
    }
}

export function validateTel(item, errors) {
    const {
        telAreaCode,
        tel,
        telExt,
    } = item;
    errors.tel = commonValidateTel({
        telAreaCode,
        tel,
        telExt,
        isRequired: false,
    });
}

export function showExemptRider(message, fn) {
    $vfm.show({
        component: 'DialogBase',
        params: {
            title: '系統提示',
            content: message || '系統忙碌中，請稍後再試',
            confirmButton: '同意取消豁免附約',
            cancelButton: '取消要保人變更申請',
            closeicon: false,
        },
        on: {
            confirm() {
                $vfm.hide('DialogBase');
                if (fn) {
                    fn();
                }
            },
            closed() {
                $vfm.hide('DialogBase');
                router.push({ name: routeName.CLOUD_E_COUNTER_HOME });
            },
        },
    });
};

function validateBirthday(birthday, userData) {
    if (!birthday) return `${userData.applicant.field.birthday}未填寫，請確認！`;
    const [year, month, day] = birthday.split('/').map(Number);
    const birthDate = new Date(year, month - 1, day);
    const currentDate = new Date();
    let age = currentDate.getFullYear() - birthDate.getFullYear();
    const monthDiff = currentDate.getMonth() - birthDate.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && currentDate.getDate() < birthDate.getDate())) {
        age--;
    }
    if (age < 18) return `要保人未成年，請確認！`;
    return '';
}

export function validateApplicantData(userData) {
    userData.applicant.errors.name = !userData.applicant.data.name ? `${userData.applicant.field.name}未填寫，請確認！` : '';
    if (userData.foreignCurrency) {
        userData.applicant.errors.engName = !userData.applicant.data.engName ? `${userData.applicant.field.engName}未填寫，請確認！` : '';
    }
    userData.applicant.errors.id = !userData.applicant.data.id ? `${userData.applicant.field.id}未填寫，請確認！` : '';
    userData.applicant.errors.country = !userData.applicant.data.country ? `${userData.applicant.field.country}未填寫，請確認！` : '';
    //userData.applicant.errors.birthday = !userData.applicant.data.birthday ? `${userData.applicant.field.birthday}未填寫，請確認！` : '';
    userData.applicant.errors.birthday = validateBirthday(userData.applicant.data.birthday, userData);
    userData.applicant.errors.relation = !userData.applicant.data.relation ? `${userData.applicant.field.relation}欄位空白，請確認！` : '';

    const enNum = /^[A-Za-z][1-2]\d{8}$/.test(userData.applicant.data.id);
    userData.applicant.errors.id = !enNum ? `身分證字號格式有誤，請確認！` : '';

};

export function validateProfessionData(userData) {
    userData.profession.errors.unit = !userData.profession.data.unit ? `請輸入${userData.profession.field.unit}` : '';
    userData.profession.errors.nature = !userData.profession.data.nature ? `請輸入${userData.profession.field.nature}` : '';
    userData.profession.errors.position = !userData.profession.data.position ? `請輸入${userData.profession.field.position}` : '';
    userData.profession.errors.content = !userData.profession.data.content ? `請輸入${userData.profession.field.content}` : '';
    userData.profession.errors.code = !userData.profession.data.code ? `請輸入${userData.profession.field.code}` : '';
    if (userData.partTimeFormVisible) {
        userData.profession.errors.partTimeCode = !userData.profession.data.partTimeCode ? `請輸入兼職代碼` : '';
        userData.profession.errors.partTimeContent = !userData.profession.data.partTimeContent ? `請輸入兼職工作內容` : '';
    } else {
        userData.profession.errors.partTimeCode = '';
        userData.profession.errors.partTimeContent = '';
    }
};

export function clearCityValue(item) {
    item.city = '';
    item.cityArea = '';
    // item.errors.city = '';
    // item.errors.cityArea = '';
    item.address = '';
    // item.errors.address = '';
};

export function setCityValue(item) {
    item.cityArea = '';
    // item.errors.city = '';
    // item.errors.cityArea = '';
    item.address = '';
    // item.errors.address = '';
};

export function setCityArea(item) {
    // item.errors.cityArea = '';
    item.address = '';
    // item.errors.address = '';
};

export function clearTel(item) {
    if (!item.telAreaCode) {
        item.tel = '';
        item.telExt = '';
        // item.errors.tel = '';
    }
};

export function getData(pageData, userData) {
    pageData.isLoading = 6;
    postRelation().then(res => {
        userData.relationList = res.data.relationList;
    }).catch(ex => {
        openPopupCatchMessage(ex);
    }).finally(() => {
        pageData.isLoading--;
    });
    postProfession().then(res => {
        userData.professionList = res.data.professionList;
    }).catch(ex => {
        openPopupCatchMessage(ex);
    }).finally(() => {
        pageData.isLoading--;
    });

    getCityInfo().then(res => {
        userData.cityInfo.countyList = res.data.cityInfoList.reduce((group, item) => {
            const { city } = item;
            group[city] = group[city] || [];
            group[city].push({ ...item, showText: `${item.zip} ${item.area}` });
            return group;
        }, {});
        userData.cityInfo.cityList = Object.keys(userData.cityInfo.countyList);
        Object.values(userData.cityInfo.countyList).forEach(item => {
            item.forEach(i => {
                i.value = i.area;
            });
        });
    }).catch(ex => {
        openPopupCatchMessage(ex);
    }).finally(() => {
        pageData.isLoading--;
    });
    getMobileCodeInfo().then(res => {
        userData.mobileCodeList = res.data.mobileCodeList.map(i => {
            i.label = `${i.text}(+${i.value})`;
            return i;
        });
    }).catch(ex => {
        openPopupCatchMessage(ex);
    }).finally(() => {
        pageData.isLoading--;
    });

    postInfo().then(res => {
        userData.exemptRiderList = res.data.exemptRiderList;
        userData.foreignCurrency = res.data.foreignCurrency;
    }).catch(ex => {
        openPopupCatchMessage(ex);
    }).finally(() => {
        pageData.isLoading--;
    });

    postBusinessData().then(res => {
        userData.businessDataList = res.data.businessDataList
    }).catch(ex => {
        openPopupCatchMessage(ex);
    }).finally(() => {
        pageData.isLoading--;
    });
};

export function getErrors(errors) {
    const array = [];
    Object.keys(errors).forEach(k => {
        if (errors[k]) {
            if (typeof errors[k] === 'string') {
                array.push(errors[k]);
            } else if (typeof errors[k] === 'object') {
                array.push(...getErrors(errors[k]));
            }
        }
    });
    return array;
}

export function validateForm(userData) {
    validateApplicantData(userData);
    validateProfessionData(userData);
    validateAddress2(userData.connectionInfo.data.applicantInfo, userData.connectionInfo.errors.applicantInfo);
    validateAddress2(userData.connectionInfo.data.chargeInfo, userData.connectionInfo.errors.chargeInfo);
    validateEmail(userData.connectionInfo.data, userData.connectionInfo.errors);
    validateTel(userData.connectionInfo.data.applicantInfo, userData.connectionInfo.errors.applicantInfo)
    validateTel(userData.connectionInfo.data.chargeInfo, userData.connectionInfo.errors.chargeInfo);
    validateMobile(userData.connectionInfo.data, userData.connectionInfo.errors);
}

export function getProfessionSubData(data, userData, pageData) {
    pageData.isLoading = 1
    userData.professionSubList = [];
    postProfessionSub(data).then(res => {
        userData.professionSubList = res.data.professionList;
    }).catch(ex => {
        openPopupCatchMessage(ex);
    }).finally(() => {
        pageData.isLoading--;
    })
}

export function validateAddress2(item, errors) {
    const {
        address,
        city,
        cityArea,
    } = item;

    if (!address && !city && !cityArea) {
        errors.address = '';
        return;
    };

    if (!city) {
        errors.address = '請輸入縣市';
        return;
    }

    if (!cityArea) {
        errors.address = '請輸入鄉鎮';
        return;
    }

    if (!address) {
        errors.address = '請輸入地址';
        return;
    }

    const en = /^[^a-zA-Z]+$/.test(item.address);
    if (!en) {
        errors.address = '不接受英文地址，請改以中文輸入';
    } else {
        const message = checkAddress(address).msg;
        errors.address = message[0] || '';
    }

    const chuyin = /[\u3105-\u3129]/.test(item.address);

    if (chuyin) {
        errors.address = '地址不接受有注音符號，請確認';
    }

    // if (city === '' || cityArea === '' || address === '') {
    //     errors.city = item.city === '' ? '請輸入縣市' : '';
    //     errors.cityArea = item.cityArea === '' ? '請輸入鄉鎮' : '';
    //     errors.address = item.address === '' ? '請輸入地址' : '';
    // } else {
    //     errors.city = '';
    //     errors.cityArea = '';
    //     const en = /^[^a-zA-Z]+$/.test(item.address);
    //     if (!en) {
    //         errors.address = '不接受英文地址，請改以中文輸入';
    //     } else {
    //         const message = checkAddress(address).msg;
    //         errors.address = message[0] || '';
    //     }
    // }
}